import { render } from "./PromotionInput.vue?vue&type=template&id=3d43d462"
import script from "./PromotionInput.vue?vue&type=script&lang=js"
export * from "./PromotionInput.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/LCAP/LCAP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__